import { UserService } from '../../services/UserService';
import { ActionType } from './types';

export const updateWarningTime = (warningTime: number, countryId: string) => ({
  type: ActionType.UPDATE_WARNING_TIME,
  payload: UserService.updateWarningTime(warningTime, countryId),
});

export const getUserInfo = () => ({
  type: ActionType.GET_USER_INFO,
  payload: UserService.getUserInfo(),
});

export const logout = () => ({ type: ActionType.LOGOUT, payload: UserService.logout() });
export const resetLoginError = () => ({ type: ActionType.RESET_LOGIN_ERROR });
